import React, { useState } from "react";
import certificateData from "../components/certificateData";
import "../styles/certificate.css";

const Certificate = () => {
  const [teamCode, setTeamCode] = useState("");
  const [participants, setParticipants] = useState([]);

  const toTitleCase = (str) => {
    return str
      .toLowerCase()
      .split(" ")
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const handleGenerate = () => {
    if (certificateData[teamCode]) {
      setParticipants(certificateData[teamCode]);
    } else {
      alert("Invalid Team Code");
      setParticipants([]);
    }
  };

  const handleOpenCertificate = (name) => {
    const fileName = toTitleCase(name) + ".pdf";
    const filePath = `${process.env.PUBLIC_URL}/assets/certificates/${fileName}`;
    window.open(filePath, "_blank");
  };

  return (
    <div className="certificate-container">
      <div className="main-background">
        <source className="main_bg_cont" />
      </div>

      <div className="input-box">
        <h2>Generate Certificate</h2>
        <p>Enter the Mid 6 Alphanumeric digits of your TEAM CODE</p>
        <p>For eg.: If your Team code is 'INNO-A1B2C3-1234'</p>
        <p>Then just enter 'A1B2C3'</p>
        <div className="input-wrapper">
          <span className="prefix">INNOVASTRA - </span>
          <input
            type="text"
            value={teamCode}
            onChange={(e) => setTeamCode(e.target.value)}
            placeholder="Enter Mid 6 digits"
          />
        </div>
        <button onClick={handleGenerate}>Generate</button>
      </div>

      {participants.length > 0 && (
        <div className="certificate-list">
          <h3>Team: {teamCode}</h3>
          <p>Click on the name to open and download the certificate.</p>
          <ul>
            {participants.map((name, index) => (
              <li key={index}>
                <a
                  href={`${process.env.PUBLIC_URL}/assets/certificates/${toTitleCase(name)}.pdf`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {name}
                </a>
              </li>
            ))}
          </ul>

          <div className="guide-box">
            <ul></ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default Certificate;
